module.exports = __webpack_public_path__ + "static/media/logoInfo.bbb4fe80.png";